import React, { useState, createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "../store/Actions/actions";
import { cloneDeep, remove } from "lodash";
import DragMark from "../assets/images/dragMark.png";
import shortid from "shortid";
import { Flex, Menu, message, notification, Spin } from "antd";
import { reset } from "@amplitude/analytics-browser";

let dragIcon = document.createElement("img");
dragIcon.src = DragMark;

const DragAndDropContext = createContext();

const DragAndDropProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { layout, layoutTitle } = useSelector((state) => state.present);

  const [notificationApi, notificationContext] = notification.useNotification();

  const [element, setElement] = useState(null);
  const [removedFromParent, setRemovedFromParent] = useState(null);
  const [removedElementIndex, seRemovedElementIndex] = useState(null);
  const [dragOverElement, setDragOverElement] = useState(null);
  const [dragOverElementIndex, setDragOverElementIndex] = useState(null);
  const [addIndex, setAddIndex] = useState(null);
  const [dragOverParent, setDragOverParent] = useState(null);
  const [dragOverParentIsNested, setadragOverParentIsNested] = useState(false);
  const [dragAndDropError, setDragAndDropError] = useState(null);
  const [barLocation, setBarLocation] = useState(null);
  const [dragOverColumnIndex, setDragOverColumnIndex] = useState(null);

  const onDrag = (
    e,
    element = null,
    removedFromParent = null,
    removedElementIndex = null
  ) => {
    if (element.data === undefined) {
      return;
    }
    console.log("element", element);
    console.log("removedFromParent", removedFromParent);
    console.log("removedElementIndex", removedElementIndex);
  
    e.dataTransfer.setDragImage(dragIcon, 20, 20);
    setElement(element);
    setRemovedFromParent(removedFromParent);
    seRemovedElementIndex(removedElementIndex);
  };

  // TODO: Change all onDrag to onDragStart to increase performance
  const onDragStart = (
    e,
    element = null,
    removedFromParent = null,
    removedElementIndex = null
  ) => {
    if (element.data === undefined) {
      return;
    }
    e.dataTransfer.setDragImage(dragIcon, 20, 20);
    setElement(element);
    setRemovedFromParent(removedFromParent);
    seRemovedElementIndex(removedElementIndex);
  };

  const onDragOver = (e) => {
    if (
      (element && element.data === undefined) ||
      element === undefined ||
      element === null
    ) {
      return;
    } else {
      e.stopPropagation();
      e.preventDefault();
      determineDropAboveOrBelow(e);
    }
  };
  const onDragEnter = (
    e,
    dragOverElement = null,
    dragOverElementIndex = null,
    dragOverParent = { data: null, id: null },
    dragOverColumnIndex = null,
    dragOverParentIsNested = false
  ) => {
    e.stopPropagation();
    e.preventDefault();

    //Prevent the element from being dragged into itself and causing an error
    if (element === dragOverElement || element === null) {
      return;
    }

    setDragOverElement(dragOverElement);
    setDragOverElementIndex(dragOverElementIndex);
    setDragOverParent(dragOverParent);
    setadragOverParentIsNested(dragOverParentIsNested);
    setDragOverColumnIndex(dragOverColumnIndex);
  };
  const onDragEnd = () => {
    if (element === null) {
      return;
    }
    resetState();
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    //Clone the layout to avoid mutating the state directly
    const newLayout = cloneDeep(layout);

    //Errors and edge cases to handle first before proceeding
    if (checkErrorConditions() === true) {
      resetState();
      return;
    }
    // adds appropriate properties

    if (removedFromParent.id === "block") {
      //if Dragging in a block with multiple elements
      //if dragging over the entire  canvas
      if (["canvas-drop-container"].includes(dragOverParent.data)) {
        if (dragOverElement === null) {
          element.data.forEach((item) => {
            newLayout.push(item);
          });
        } else {
          const targetIndex = newLayout.findIndex(
            (item) => item.id === dragOverElement.id
          );
          if (targetIndex !== -1) {
            let num = 0;
            element.data.forEach((item) => {
              newLayout.splice(addIndex + num, 0, item);
              num++;
            });
          }
        }
      } else {
        if (dragOverElement === null) {
          newLayout.forEach((item) => {
            if (item.columns && dragOverParent.id === item.id) {
              element.data.forEach((elementItems) => {
                item.columns[
                  Object.keys(item.columns)[dragOverColumnIndex]
                ].push(elementItems);
                // item.columns["c" + (dragOverColumnIndex + 1)].push(
                //   elementItems
                // );
              });
            } else if (item.columns && dragOverParent.id !== item.columns.id) {
              Object.keys(item.columns).forEach((col) => {
                item.columns[col].forEach((colItem) => {
                  if (
                    colItem.columns &&
                    (dragOverParent.id === colItem.id) &
                      Array.isArray(element.data)
                  ) {
                    notificationApi["error"]({
                      message: "Drag Block Error",
                      description:
                        "Cannot nest elements any further, maximum nesting level reached",
                      placement: "bottomRight",
                    });
                  }
                });
              });
            }
          });
        } else {
          newLayout.forEach((item) => {
            item.columns &&
              Object.keys(item.columns).forEach((col) => {
                let hasAdded = false;
                item.columns[col].forEach((colItem) => {
                  if (colItem.id === dragOverElement.id) {
                    let num = 0;
                    if (!hasAdded) {
                      element.data.forEach((elementItems) => {
                        item.columns[col].splice((addIndex + num), 0, elementItems);
                        num++;
                        hasAdded = true;
                      });
                    }
                  } else if (colItem.columns) {
                    Object.keys(colItem.columns).forEach((nestedColKey) => {
                      colItem.columns[nestedColKey].forEach((nestedCol) => {
                        if (nestedCol.id === dragOverElement.id) {
                          notificationApi["error"]({
                            message: "Drag Block Error",
                            description:
                              "Cannot nest elements any further, maximum nesting level reached",
                            placement: "bottomRight",
                          });
                        }
                      });
                    });
                  }
                });
              });
          });
        }
      }

      dispatch(
        actionTypes.layout({ titleLayout: layoutTitle, layout: newLayout })
      );
    }
    // If dragging from the toolbar
    else if (removedFromParent.data === "toolbar") {
      //adding
      if (["canvas-drop-container"].includes(dragOverParent.data)) {
        var tweakedElement = { ...element, id: "Flimp-" + shortid() };

        if (element.data === "FORM") {
          tweakedElement = {
            ...tweakedElement,
            identifier: `Data-${shortid()}`,
          };
        }
        if (dragOverElement === null) {
          newLayout.push(tweakedElement);
        } else {
          const targetIndex = newLayout.findIndex(
            (item) => item.id === dragOverElement.id
          );
          if (targetIndex !== -1) {
            newLayout.splice(addIndex, 0, tweakedElement);
          }
        }
      } else {
        var tweakedElement = { ...element, id: "Flimp-" + shortid() };

        if (element.data === "FORM") {
          tweakedElement = {
            ...tweakedElement,
            identifier: `Data-${shortid()}`,
          };
        }
        if (dragOverElement === null) {
          newLayout.forEach((item) => {
            if (item.columns && dragOverParent.id === item.id) {
              item.columns[Object.keys(item.columns)[dragOverColumnIndex]].push(
                tweakedElement
              );
              // item.columns["c" + (dragOverColumnIndex + 1)].push(
              //   tweakedElement
              // );
            } else if (item.columns && dragOverParent.id !== item.columns.id) {
              Object.keys(item.columns).forEach((col) => {
                item.columns[col].forEach((colItem) => {
                  if (colItem.columns && dragOverParent.id === colItem.id) {
                    colItem.columns[
                      Object.keys(colItem.columns)[dragOverColumnIndex]
                    ].push(tweakedElement);
                    // colItem.columns["c" + (dragOverColumnIndex + 1)].push(
                    //   tweakedElement
                    // );
                  }
                });
              });
            }
          });
        } else {
          let hasAdded = false;
          newLayout.forEach((item) => {
            if (hasAdded) return;
            if (item.columns) {
              Object.keys(item.columns).forEach((col) => {
                if (hasAdded) return;
                item.columns[col].forEach((colItem) => {
                  if (hasAdded) return;
                  if (colItem.id === dragOverElement.id) {
                    item.columns[col].splice(addIndex, 0, tweakedElement);
                    hasAdded = true;
                    return;
                  } else if (colItem.columns) {
                    Object.keys(colItem.columns).forEach((nestedColKey) => {
                      colItem.columns[nestedColKey].forEach((nestedCol) => {
                        if (hasAdded) return;
                        if (nestedCol.id === dragOverElement.id) {
                          colItem.columns[nestedColKey].splice(
                            addIndex,
                            0,
                            tweakedElement
                          );
                          hasAdded = true;
                          return;
                        }
                      });
                    });
                  }
                });
              });
            }
          });
        }
      }
      dispatch(
        actionTypes.layout({ titleLayout: layoutTitle, layout: newLayout })
      );
    }
    // if dragging from the canvas
    else {
      //removing
      if (removedFromParent.data === "canvas-drop-container") {
        newLayout.splice(removedElementIndex, 1);
      }
      if (["Row", "Accordion"].includes(removedFromParent.data)) {
        newLayout.forEach((item) => {
          item.columns &&
            Object.keys(item.columns).forEach((colKey) => {
              item.columns[colKey].forEach((colItem) => {
                if (colItem.id === element.id) {
                  item.columns[colKey].splice(removedElementIndex, 1);
                } else if (colItem.columns) {
                  Object.keys(colItem.columns).forEach((nestedColKey) => {
                    colItem.columns[nestedColKey].forEach((nestedColItem) => {
                      if (nestedColItem.id === element.id) {
                        colItem.columns[nestedColKey].splice(
                          removedElementIndex,
                          1
                        );
                      }
                    });
                  });
                }
              });
            });
        });
      }
      // Adding
      //If dragOverParent === "canvas-drop-container"
      if (["canvas-drop-container"].includes(dragOverParent.data)) {
        if (dragOverElement === null) {
          newLayout.push(element);
        } else {
          // add
          newLayout.splice(addIndex, 0, element);
        }
      }
      //If dragOverParent === "Row" or "Accordion"
      else {
        //if dragging over an empty col
        if (dragOverElement === null) {
          newLayout.forEach((item) => {
            if (item.columns && dragOverParent.id === item.id) {
              console.log(Object.keys(item.columns));
              console.log(Object.keys(item.columns)[dragOverColumnIndex + 1]);
              console.log(dragOverColumnIndex);
              //  Object.keys(item.columns)[(dragOverColumnIndex + 1)].push(element);
              item.columns[Object.keys(item.columns)[dragOverColumnIndex]].push(
                element
              );
            } else if (item.columns && dragOverParent.id !== item.columns.id) {
              Object.keys(item.columns).forEach((col) => {
                item.columns[col].forEach((colItem) => {
                  if (colItem.columns && dragOverParent.id === colItem.id) {
                    colItem.columns[
                      Object.keys(colItem.columns)[dragOverColumnIndex]
                    ].push(element);
                  }
                });
              });
            }
          });
        }
        //dragging over a column with elements in it
        else {
          let hasAdded = false;
          newLayout.forEach((item) => {
            if (hasAdded) return;

            if (item.columns) {
              Object.keys(item.columns).forEach((colKey) => {
                if (hasAdded) return;

                item.columns[colKey].forEach((colItem) => {
                  if (hasAdded) return;

                  if (colItem.id === dragOverElement.id) {
                    item.columns[colKey].splice(addIndex, 0, element);
                    hasAdded = true;
                    return;
                  }

                  if (colItem.columns && dragOverElement.id !== item.id) {
                    Object.keys(colItem.columns).forEach((nestedColKey) => {
                      if (hasAdded) return;

                      colItem.columns[nestedColKey].forEach((nestedColItem) => {
                        if (hasAdded) return;

                        if (nestedColItem.id === dragOverElement.id) {
                          colItem.columns[nestedColKey].splice(
                            addIndex,
                            0,
                            element
                          );
                          hasAdded = true;
                          return;
                        }
                      });
                    });
                  }
                });
              });
            }
          });
        }
      }

      dispatch(
        actionTypes.layout({ titleLayout: layoutTitle, layout: newLayout })
      );
    }

    resetState();
  };

  const checkErrorConditions = () => {
    if (dragOverElement && !dragOverElement.id) {
      return true;
    }
    //checking to see if properly have the data for the element we are dragging
    if (element === null) {
      return true;
    }
    if (dragOverParent === null) {
      return true;
    }
    //checking to see if the element is being dragged into itself
    if (element.id === dragOverParent.id) {
      notificationApi["error"]({
        message: "Drag Row/Col Error",
        description:
          "Cannot drag Row/Col element into itself, please try again",
        placement: "bottomRight",
      });
      return true;
    }
    //checking to see if the element is being dragged anywhere yet
    if (
      dragOverParent === null ||
      dragOverParent.data === null ||
      dragOverParent.data === undefined
    ) {
      return true;
    }
    //checking to see if the element is being dragged into a nested element
    if (
      (dragOverParentIsNested === true) &
      ["Row", "Accordion"].includes(element.data)
    ) {
      notificationApi["error"]({
        message: "Drag Row/Col Error",
        description:
          "Cannot nest elements any further, maximum nesting level reached",
        placement: "bottomRight",
      });

      return true;
    }
    //checking to see if the element being dragged is nested and is going into a row or accordion
    if (["Row, Accordion"].includes(dragOverParent.data) & element.columns) {
      Object.keys(element.columns).forEach((col) => {
        col.forEach((colItem) => {
          if (colItem.columns) {
            notificationApi["error"]({
              message: "Drag Row/Col Error",
              description:
                "Cannot nest elements any further, maximum nesting level reached",
              placement: "bottomRight",
            });
            return true;
          }
        });
      });
    }
  };
  const resetState = () => {
    setDragAndDropError(null);
    setElement(null);
    setRemovedFromParent(null);
    seRemovedElementIndex(null);
    setDragOverElement(null);
    setDragOverElementIndex(null);
    setAddIndex(null);
    setDragOverParent(null);
    setadragOverParentIsNested(false);
  };
  const determineDropAboveOrBelow = (e) => {
    // checking to see if the element is being dragged into itself
    if (element === dragOverElement) {
      return;
    }
    if (removedFromParent === null) {
      return;
    }
    if (removedFromParent && removedFromParent.id === null) {
      return;
    }
    //get variables describing where on the element the drag is occuring in terms of cursor position
    const dragOverElementRect =
      dragOverElement &&
      document.getElementById(dragOverElement.id).getBoundingClientRect();
    const dragOverElementHeight =
      dragOverElementRect && dragOverElementRect.height;
    const halfDragOverElementHeight =
      dragOverElementHeight && dragOverElementHeight / 2;

    // check where the cursor is in relation to the element
    const yOffset = dragOverElementRect && e.clientY - dragOverElementRect.top; //y position within the element.

    if (
      dragOverParent &&
      dragOverElement &&
      removedFromParent.id === dragOverParent.id
    ) {
      if (removedElementIndex < dragOverElementIndex) {
        if (yOffset < halfDragOverElementHeight) {
          setBarLocation("Top");
          setAddIndex(dragOverElementIndex - 1);
        } else {
          setBarLocation("Bottom");
          setAddIndex(dragOverElementIndex);
        }
      } else {
        if (yOffset < halfDragOverElementHeight) {
          setBarLocation("Top");
          setAddIndex(dragOverElementIndex);
        } else {
          setBarLocation("Bottom");
          setAddIndex(dragOverElementIndex + 1);
        }
      }
    } else {
      if (yOffset < halfDragOverElementHeight) {
        setBarLocation("Top");
        setAddIndex(dragOverElementIndex);
      } else {
        setBarLocation("Bottom");
        setAddIndex(dragOverElementIndex + 1);
      }
    }
  };

  return (
    <DragAndDropContext.Provider
      value={{
        onDrop,
        onDrag,
        onDragStart,
        onDragOver,
        onDragEnter,
        onDragEnd,
        setElement,
        setRemovedFromParent,
        element,
        dragOverElement,
        dragOverElementIndex,
        dragOverColumnIndex,
        addIndex,
        dragOverParent,
        barLocation,
      }}
    >
      {children}
      {notificationContext}
    </DragAndDropContext.Provider>
  );
};

export { DragAndDropContext, DragAndDropProvider };
